// src/components/PrivateRoute.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const IS_LOCAL_DEV = window.location.hostname === 'localhost';

/**
 * PrivateRoute component - protects routes from unauthenticated access
 * Redirects to /login if user is not authenticated
 * NOTE: Auth check is bypassed on localhost for local development
 */
export default function PrivateRoute({ children }) {
  const { currentUser, loading } = useAuth();

  // Bypass auth entirely on localhost
  if (IS_LOCAL_DEV) {
    return children;
  }

  // Show loading state while checking authentication
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#18365E] mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  // Render protected content if authenticated
  return children;
}